import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import React, { MouseEventHandler, useEffect, useState } from "react";
import { ArrowDropDown, ArrowDropUp, Padding } from "@mui/icons-material";
import style from "./style.module.scss";
import { ExpandDownIcon, ExpandUpIcon } from "../../assets/icons";

interface InputNumberProps {
  readOnly?: boolean;
  default?: number;
  disabled?: boolean;
  onChange: (limit: number) => void;
}

const InputNumber = React.forwardRef((props: InputNumberProps, ref: any) => {
  const { onChange, ...relatedProps } = props;
  const [value, setValue] = useState(props.default || 1);
  const increment = () => {
    if (props.disabled || props.readOnly) return;
    setValue((state) => state + 1);
  };
  const decrement = () => {
    if (props.disabled || props.readOnly) return;
    setValue((state) => {
      if (state === 1) return 1;
      return state - 1;
    });
  };

  useEffect(() => {
    props.onChange(value);
  }, [value]);

  return (
    <TextField
      ref={ref}
      {...relatedProps}
      sx={{
        "& > .MuiInputBase-root": { margin: 0, padding: 0, height: "24px", borderRadius: "4px" },
        "& > .MuiInputBase-root.Mui-disabled svg": { pointerEvents: "none" },
        "& .MuiInputAdornment-positionStart": {
          padding: "12px 6px",
          bgcolor: "rgba(229, 231, 234, 0.50)",
          borderTopLeftRadius: "5px",
          borderBottomLeftRadius: "5px",
          margin: 0,
        },
        "& .MuiInputAdornment-positionEnd": {
          margin: 0,
        },
        "& .MuiOutlinedInput-input": {
          height: "24px",
          width: "22px",
          padding: 0,
          color: "text.dark2",
          textAlign: "center",
          fontSize: "12px",
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "normal",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#e5e7ea !important",
        },
      }}
      className={style.input_number}
      value={value}
      disabled={Boolean(props.disabled)}
      InputProps={{
        readOnly: true,
        startAdornment: (
          <InputAdornment position="start">
            <Typography component={"span"} className={style.label}>
              Limit
            </Typography>
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <Box className={style.limit_icon_wrap}>
              <ExpandUpIcon className={style.arrow_up} onClick={increment} />
              <ExpandDownIcon className={style.arrow_down} onClick={decrement} />
            </Box>
          </InputAdornment>
        ),
      }}
    />
  );
});

export default InputNumber;
